import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';

class UserService {
  #_fr = firebase.firestore();
  #_ath = firebase.auth();

  async getUser(email: string) {
    const response = await this.#_fr.collection("users").where("email", "==", email.toLowerCase()).get();  
    var data = response.docs[0].data();
    data['id'] = response.docs[0].id;

    return data || null;
  }

  async getUsers() {
    return await this.#_fr.collection("users").get();
  }

  async updateUser(userData: any) {
    return await this.#_fr.collection('users').doc(userData.id).set(userData, { merge: true });
  }

  async sendPasswordRecovery(email: string) {
    await this.#_ath.sendPasswordResetEmail(email);
  }

  async exit() {
    await this.#_ath.signOut();
  }
}

export default UserService;